import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Intro from '@/components/Intro'
import Cadastro from '@/components/Cadastro'
import Dashboard from '@/components/Dashboard'
import Conta from '@/components/Conta'
import AlterarSenha from '@/components/AlterarSenha'
import RecuperarSenha from '@/components/RecuperarSenha'
import Usuarios from '@/components/Usuarios'
import Areas from '@/components/Areas'
import Posts from '@/components/Posts'
import Agendamentos from '@/components/Agendamentos'
import Agenda from '@/components/Agenda'
import Exames from '@/components/Exames'
import Ged from '@/components/Ged'
import Sintomas from '@/components/Sintomas'
import Mural from '@/components/Mural'
import Configuracoes from '@/components/Configuracoes'
import Campanhas from '@/components/Campanhas'
import Pacientes from '@/components/Pacientes'
import Formularios from '@/components/Formularios'
import Formulario from '@/components/Formulario'
import PendentesFormularios from '@/components/PendentesFormularios'
import GerenciarFormularios from '@/components/GerenciarFormularios'
import RelatorioFormularios from '@/components/RelatorioFormularios'
import Receitas from '@/components/Receitas'
import Profissionais from '@/components/Profissionais'
import ConfirmarAgendamento from '@/components/ConfirmarAgendamento'
import GerenciarUsuarios from '@/components/GerenciarUsuarios'
import GerenciarAreas from '@/components/GerenciarAreas'
import GerenciarReceitas from '@/components/GerenciarReceitas'
import GerenciarPosts from '@/components/GerenciarPosts'
import Arquivos from '@/components/Arquivos'
import Paciente from '@/components/Paciente'
import Teleconsulta from '@/components/Teleconsulta'
import AutorizarUsoDados from '@/components/AutorizarUsoDados'
import PermissaoUsoDados from '@/components/PermissaoUsoDados'
import GerenciarCampanhasFiltros from '@/components/GerenciarCampanhasFiltros'
import FinanceiroSolicitacoes from '@/components/FinanceiroSolicitacoes'
import FinanceiroSolicitacoesDetalhes from '@/components/FinanceiroSolicitacoesDetalhes'
import FinanceiroMovimentacoes from '@/components/FinanceiroMovimentacoes'
import HonorariosMedicos from '@/components/HonorariosMedicos'
import Logs from '@/components/Logs'
import { isMobile } from 'mobile-device-detect';
var loggedRoute 	= "Dashboard";
var notLoggedRoute 	= "Login";

// if (!window.localStorage.getItem("_intro")) {
// 	notLoggedRoute 		= "Introducao";
// }

Vue.use(Router)

const checkLogin 	= (to, from, next) => {
    var self    	= this;

    console.log("checkLogin()", to, from, next)

    if (!window.localStorage.getItem("_usuario")) {
        if (to.meta.auth == false || typeof to.meta.auth == "undefined") {
	   		next();
	   		return;             	
        }
        if (to.meta.auth == true) {
        }        
    } else {
        var usuario = null;
        try {
            usuario = JSON.parse(window.localStorage.getItem("_usuario"));
            window.__usuario = usuario;
            if (usuario.cod) {
		        if (to.meta.auth == false) {
				 	_this.push({ 
					   	name: loggedRoute,
					   	params: {
					   		"reload": 1 	
					   	}
				 	}).catch(()=>{});			
				 	if (_this.currentRoute.params.reload == 1) {
				 		window.location.reload();   		
			   		}
			   		return;             	
		        }

		        if (to.meta.auth && to.meta.level) {
		        	if (to.meta.level.indexOf(usuario.tipo) == -1) {
					 	_this.push({ 
						   	name: loggedRoute
					 	}).catch(()=>{});					        		
		        	}
		        }
	            
       
		   		next();
		   		return;            
            } else {
            }

        } catch(err) {
        }
    }
    
 	_this.push({ 
	   	name: notLoggedRoute
 	}).catch(()=>{});
};

var _this = new Router({
	// mode: 'history',
  	routes: [
	    {
	      	path: '/',
	      	name: 'Dashboard',
	      	meta: {
	      		title: 		"Início",
	      	},
	      	component: Dashboard,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/login/',
	      	name: 'Login',
	      	meta: {
	      		title: 		"Login",
	      		auth: 		false,
	      	},
	      	component: Login,
	      	beforeEnter: checkLogin,
	    }, 
	    {
	      	path: '/intro/',
	      	name: 'Introducao',
	      	meta: {
	      		title: 		"Intro",
	      	},
	      	component: Intro,
	      	beforeEnter: checkLogin,
	    }, 	     
	    {
	      	path: '/cadastro/',
	      	name: 'Cadastro',
	      	meta: {
	      		title: 		"Cadastro",
	      		auth: 		false,
	      	},
	      	component: Cadastro,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/recuperar-senha/',
	      	name: 'RecuperarSenha',
	      	meta: {
	      		title: 		"Recuperar senha",
	      		auth: 		false,
	      	},
	      	component: RecuperarSenha,
	      	beforeEnter: checkLogin,
	    },	  
	    {
	      	path: '/confirmar-agendamento/',
	      	name: 'ConfirmarAgendamento',
	      	meta: {
	      		title: 		"Confirmar agendamento",
	      	},
	      	component: ConfirmarAgendamento,
	      	beforeEnter: checkLogin,
	    },	  	        	      
	    {
	      	path: '/dicas/',
	      	name: 'Posts',
	      	meta: {
	      		title: 		"Dicas semanais",
		      	backButton: true,
	      	},
	      	component: Posts,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/dicas/cadastro/',
	      	name: 'CadastrarPosts',
	      	meta: {
	      		title: 		"Cadastrar dica",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["marketing", "admin"],
		      	options: {
		      		
		      	}
	      	},
	      	component: GerenciarPosts,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/dicas/editar/',
	      	name: 'EditarPosts',
	      	meta: {
	      		title: 		"Editar dica",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["marketing", "admin"],
		      	options: {
		      		
		      	}
	      	},
	      	component: GerenciarPosts,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/configuracoes/campanhas-filtros/cadastro/',
	      	name: 'CadastrarCampanhasFiltros',
	      	meta: {
	      		title: 		"Cadastrar filtro",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
		      	options: {
		      		
		      	}
	      	},
	      	component: GerenciarCampanhasFiltros,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/configuracoes/campanhas-filtros/editar/',
	      	name: 'EditarCampanhasFiltros',
	      	meta: {
	      		title: 		"Editar filtro",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
		      	options: {
		      		
		      	}
	      	},
	      	component: GerenciarCampanhasFiltros,
	      	beforeEnter: checkLogin,
	    },		    	    	    		     
	    {
	      	path: '/agendamentos/',
	      	name: 'Agendamentos',
	      	meta: {
	      		title: 		"Agendamentos",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional", "contratante", "coordenador", "controladoria", "gerente"],
	      	},
	      	component: Agendamentos,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/teleconsulta/',
	      	name: 'Teleconsulta',
	      	meta: {
	      		title: 		"Teleconsulta",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["profissional", "contratante", "coordenador", "controladoria", "gerente"],
	      	},
	      	component: Teleconsulta,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/agenda/',
	      	name: 'Agenda',
	      	meta: {
	      		title: 		"Agenda",
		      	backButton: true,
		      	topClass: 	["transparent"],
		      	hideTitle: 	true,
	      	},
	      	component: Agenda,
	      	beforeEnter: checkLogin,
	    },		
	    {
	      	path: '/sintomas/',
	      	name: 'Sintomas',
	      	meta: {
	      		title: 		"Histórico de sintomas",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional", "contratante", "coordenador", "controladoria", "gerente"],
	      	},
	      	component: Sintomas,
	      	beforeEnter: checkLogin,
	    },			         	
	    {
	      	path: '/receitas/',
	      	name: 'Receitas',
	      	meta: {
	      		title: 		"Receitas e atestados",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional", "contratante", "coordenador", "controladoria", "gerente"],
	      	},
	      	component: Receitas,
	      	beforeEnter: checkLogin,
	    },	 		       
	    {
	      	path: '/profissionais/',
	      	name: 'Profissionais',
	      	meta: {
	      		title: 		"Novo agendamento",
		      	backButton: true,
	      	},
	      	component: Profissionais,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/mural/',
	      	name: 'Mural',
	      	meta: {
	      		title: 		"Mural",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "marketing"],
	      	},
	      	component: Mural,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/campanhas/',
	      	name: 'Campanhas',
	      	meta: {
	      		title: 		"Campanhas",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "marketing"],
	      	},
	      	component: Campanhas,
	      	beforeEnter: checkLogin,
	    },	    	    	 	   	     
	    {
	      	path: '/documentos/',
	      	name: 'Arquivos',
	      	meta: {
	      		title: 		"Meus documentos",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "coordenador", "controladoria", "gerente"],
	      	},
	      	component: Arquivos,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/exames/',
	      	name: 'Exames',
	      	meta: {
	      		title: 		"Meus exames",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "coordenador", "controladoria", "gerente"],
	      	},
	      	component: Exames,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/ged/',
	      	name: 'Ged',
	      	meta: {
	      		title: 		"GED",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "coordenador", "controladoria", "gerente"],
	      	},
	      	component: Ged,
	      	beforeEnter: checkLogin,
	    },	 	    	    
	    {
	      	path: '/configuracoes/',
	      	name: 'Configuracoes',
	      	meta: {
	      		title: 		"Configurações",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: Configuracoes,
	      	beforeEnter: checkLogin,
	    },	 	    	       
	    {
	      	path: '/minha-conta/',
	      	name: 'Conta',
	      	meta: {
	      		title: 		"Minha conta",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "admin", "profissional", "marketing", "criacao", "controladoria", "gerente", "coordenador"],
	      	},
	      	component: Conta,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/alterar-senha/',
	      	name: 'AlterarSenha',
	      	meta: {
	      		title: 		"Alterar senha",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "admin", "profissional", "marketing", "criacao", "controladoria", "gerente", "coordenador"],
	      	},
	      	component: AlterarSenha,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/pacientes/',
	      	name: 'Pacientes',
	      	meta: {
	      		title: 		"Pacientes",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional", "controladoria", "gerente", "coordenador"],
		      	options: {
		      		"tipo": "contratante" 
		      	}
	      	},
	      	component: Pacientes,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/formularios/relatorio',
	      	name: 'RelatorioFormularios',
	      	meta: {
	      		title: 		"Relatório de formulários",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
		      	options: {
		      		
		      	}
	      	},
	      	component: RelatorioFormularios,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/formularios/pendentes',
	      	name: 'PendentesFormularios',
	      	meta: {
	      		title: 		"Formulários pendentes",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional", "controladoria", "gerente", "coordenador"],
		      	options: {
		      		
		      	}
	      	},
	      	component: PendentesFormularios,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/formularios',
	      	name: 'Formularios',
	      	meta: {
	      		title: 		"Gerenciar formulários",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
		      	options: {
		      		
		      	}
	      	},
	      	component: Formularios,
	      	beforeEnter: checkLogin,
	    },	 	   
	    {
	      	path: '/formulario',
	      	name: 'Formulario',
	      	meta: {
	      		title: 		"Formulário",
		      	auth: 		true,
		      	backButton: true,
		      	// level: 		["admin"],
		      	options: {
		      		
		      	}
	      	},
	      	component: Formulario,
	      	beforeEnter: checkLogin,
	    },	 	     	
	    {
	      	path: '/formularios/cadastro',
	      	name: 'CadastrarFormularios',
	      	meta: {
	      		title: 		"Criar formulário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarFormularios,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/formularios/editar',
	      	name: 'EditarFormularios',
	      	meta: {
	      		title: 		"Editar formulário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarFormularios,
	      	beforeEnter: checkLogin,
	    },	           
	    {
	      	path: '/emitir-receita',
	      	name: 'GerenciarReceitas',
	      	meta: {
	      		title: 		"Emitir receita digital",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["profissional"],
		      	options: {
		      		
		      	}
	      	},
	      	component: GerenciarReceitas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/pacientes/detalhes',
	      	name: 'Paciente',
	      	meta: {
	      		title: 		"Prontuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["profissional", "admin", "controladoria", "gerente", "coordenador"],
		      	options: {
		      		
		      	}
	      	},
	      	component: Paciente,
	      	beforeEnter: checkLogin,
	    },		        
	    {
	      	path: '/usuarios/',
	      	name: 'UsuariosGeral',
	      	meta: {
	      		title: 		"Usuários",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "criacao"],
		      	options: {
		      		"cadastrarBotaoTexto": 		"Cadastrar usuário",
		      		"cadastrarBotaoNome": 		"CadastrarUsuariosGeral",
		      		"editarBotaoNome": 			"EditarUsuariosGeral",
		      		"tipo": 					"admin,profissional,marketing,contratante,criacao,coordenador,gerente,controladoria" 
		      	}
	      	
	      	},
	      	component: Usuarios,
	      	beforeEnter: checkLogin,
	    },	    	
	    {
	      	path: '/areas/',
	      	name: 'Areas',
	      	meta: {
	      		title: 		"Áreas",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "criacao"],
		      	options: {}
	      	
	      	},
	      	component: Areas,
	      	beforeEnter: checkLogin,
	    },	    		    	    	    
	    {
	      	path: '/areas/cadastro',
	      	name: 'CadastrarAreas',
	      	meta: {
	      		title: 		"Cadastrar área",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "criacao"]
	      	},
	      	component: GerenciarAreas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/areas/editar',
	      	name: 'EditarAreas',
	      	meta: {
	      		title: 		"Editar área",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "criacao"]
	      	},
	      	component: GerenciarAreas,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/usuarios/cadastro',
	      	name: 'CadastrarUsuariosGeral',
	      	meta: {
	      		title: 		"Cadastrar usuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "criacao"]
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/usuarios/editar',
	      	name: 'EditarUsuariosGeral',
	      	meta: {
	      		title: 		"Editar usuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "criacao"]
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/logs',
	      	name: 'Logs',
	      	meta: {
	      		title: 		"Logs",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: Logs,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/permissoes/visualizar-dados',
	      	name: 'PermissaoUsoDados',
	      	meta: {
	      		title: 		"Permissões de uso de dados",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: PermissaoUsoDados,
	      	beforeEnter: checkLogin,
	    },	    	    
	    {
	      	path: '/autorizar-uso-de-dados',
	      	name: 'AutorizarUsoDados',
	      	meta: {
	      		title: 		"Autorizar uso de dados",
	      	},
	      	component: AutorizarUsoDados,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/honorarios-medicos',
	      	name: 'HonorariosMedicos',
	      	meta: {
	      		title: 		"Honorários médicos",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional"],
	      	},
	      	component: HonorariosMedicos,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/financeiro/solicitacoes',
	      	name: 'FinanceiroSolicitacoes',
	      	meta: {
	      		title: 		"Aprovações",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "coordenador", "gerente", "controladoria"],
	      	},
	      	component: FinanceiroSolicitacoes,
	      	beforeEnter: checkLogin,
	    },	  
	    {
	      	path: '/financeiro/solicitacoes/detalhes',
	      	name: 'FinanceiroSolicitacoesDetalhes',
	      	meta: {
	      		title: 		"Informações da solicitação",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "coordenador", "gerente", "controladoria"],
	      	},
	      	component: FinanceiroSolicitacoesDetalhes,
	      	beforeEnter: checkLogin,
	    },	  	    
	    {
	      	path: '/financeiro/movimentacoes',
	      	name: 'FinanceiroMovimentacoes',
	      	meta: {
	      		title: 		"Orçamento",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "coordenador", "gerente", "controladoria"],
	      	},
	      	component: FinanceiroMovimentacoes,
	      	beforeEnter: checkLogin,
	    },	  	    	    
	    { path: '*', redirect: '/' }
  	]
})

const scrollPositions = Object.create(null)

_this.beforeEach((to, from, next) => {

  	let element = $(".dashboard-content-inner")[0];
  	if (element) {
	    scrollPositions[from.name] = element.scrollTop
  	}

  	next()
})

window.addEventListener('popstate', () => {
	setTimeout(function() {
	  	let currentRouteName = _this.history.current.name
	  	let element = $(".dashboard-content-inner")[0];
	  	if (element && scrollPositions[currentRouteName]) {
	    	element.scrollTop = scrollPositions[currentRouteName];
	    	scrollPositions[currentRouteName] = null;
	  	}
	}, 100);
})

export default _this;


// WEBPACK FOOTER //
// ./src/router/index.js